export type Deadlines = {
  [key: string]: {
    time: string,
  },
}

export type ProviderDeadlineGroupModel = {
  deadlines: Deadlines,
  default: boolean,
  id: number,
  provider_id: number,
  title: string,
}

const state = {
  deadlines: {},
  default: false,
  id: null,
  provider_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'provider_id' },
  { key: 'title' },
]

export default state
